import { render, staticRenderFns } from "./currencyAdvantage.vue?vue&type=template&id=f7939300"
import script from "./currencyAdvantage.vue?vue&type=script&lang=js"
export * from "./currencyAdvantage.vue?vue&type=script&lang=js"
import style0 from "./currencyAdvantage.vue?vue&type=style&index=0&id=f7939300&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports